module.exports = __webpack_public_path__ + "img/en.5cdaa44b.png";